import { render, staticRenderFns } from "./soldierInfo.vue?vue&type=template&id=42535ac4"
import script from "./soldierInfo.vue?vue&type=script&lang=js"
export * from "./soldierInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports